<template>
    <div class="flex items-center">

          <div v-show="isHidden">
            <p>
              {{content}}<a href="#" v-on:click="isHidden = !isHidden" class="text-xxs align-middle"><i aria-hidden="true" class="material-icons align-middle text-sm mx-1">edit</i>Change</a>
            </p>
          </div>
          <div v-if="!isHidden" class="flex items-center">
            <div class="flex pr-1 w-10/12">
              <input class="w-full" id="groupName" type="text"
                     :placeholder="content"
                     @keydown.enter="putItem"
                     v-model="value"
                     autofocus
              />
            </div>
            <div class="w-2/12">
              <button @click="putItem" type="submit" class="commitbutton p-0 inline-block w-10"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i></button>
            </div>
          </div>
        
      </div>
</template>

<script>
import axios from 'axios'

  export default {

        props: {
            content: '',
            route:'',
            routeparam:'',
        },

        data() {
          return {
            isHidden: true,
            success: false,
            loaded: true,
            value:'',
          }
        },

        methods: {

          formfocus() {
              document.getElementById("groupName").focus();
          },
          mounted(){
            this.formfocus()
          },

          putItem: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.put(this.route,
                { [this.routeparam]: this.value }
              )
              .then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },
      }
</script>
